import React from "react";
import LoginForm from "./Login_Form";
import "containers/Account/Login/Login.css";
import TextTheme from "components/General/Text/TextTheme";

class Login extends React.Component {
	render() {
		return (
			<section style={{ height: "10px" }}>
				<div className="login-box__title">
					<TextTheme
						message="Login"
						textAlign="center"
						className="text_large"
					/>
				</div>
				<LoginForm />
			</section>
		);
	}
}

export default Login;
